import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_PROVIDER_DEMO_IEAM_2 = {
  title: "Uploading\n application artifacts",
  subtitle: "Use case Provider demo",
  text: "This is followed by uploading the application \nartifacts in industry-standard formats.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_107"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_105"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/IEAM/IEAM_Use_case_provider_demo_screens_01_BG.png",
  rightSideImage: "ENG/IEAM/IEAM_Use_case_provider_demo_screens_02.png",
};
